import { FC } from 'react';

const ReadingList = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" width="24" height="24">
      <g className="nc-icon-wrapper">
        <path
          fill="#67757F"
          d="M39 24c0 2.209-1.791 2-4 2H9c-2.209 0-4 .209-4-2l2-12c.125-1.917 1.791-4 4-4h22c2.209 0 3.791 2.208 4 4l2 12z"
        ></path>
        <path
          fill="#CCD6DD"
          d="M32 17a2 2 0 01-2 2H14a2 2 0 01-2-2V9a2 2 0 012-2h16a2 2 0 012 2v8z"
        ></path>
        <path
          fill="#E1E8ED"
          d="M34 21a2 2 0 01-2 2H12a2 2 0 01-2-2v-8a2 2 0 012-2h20a2 2 0 012 2v8z"
        ></path>
        <path
          fill="#F5F8FA"
          d="M36 25a2 2 0 01-2 2H10a2 2 0 01-2-2v-8a2 2 0 012-2h24a2 2 0 012 2v8z"
        ></path>
        <path
          fill="#9AAAB4"
          d="M39 35a4 4 0 01-4 4H9a4 4 0 01-4-4V24a4 4 0 014-4h26a4 4 0 014 4v11z"
        ></path>
        <path fill="#67757F" d="M18 16zm0 0z"></path>
        <path
          fill="#FCAB40"
          d="M26 5h-5a2 2 0 00-2 2v1h4a2 2 0 012 2h1a2 2 0 002-2V7a2 2 0 00-2-2z"
        ></path>
        <path
          fill="#5DADEC"
          d="M22 9h-5a2 2 0 00-2 2v1h4a2 2 0 012 2h1a2 2 0 002-2v-1a2 2 0 00-2-2z"
        ></path>
        <path
          fill="#E75A70"
          d="M20 16a2 2 0 01-2 2h-5a2 2 0 01-2-2v-1a2 2 0 012-2h5a2 2 0 012 2v1z"
        ></path>
        <path
          fill="#67757F"
          d="M29 32a2 2 0 01-2 2H17a2 2 0 01-2-2v-5a2 2 0 012-2h10a2 2 0 012 2v5zm-11-4z"
        ></path>
        <path
          fill="#E1E8ED"
          d="M27 31a1 1 0 01-1 1h-8a1 1 0 01-1-1v-3a1 1 0 011-1h8a1 1 0 011 1v3z"
        ></path>
      </g>
    </svg>
  );
};

export default ReadingList;
